import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpLoaderService } from '../services/http-loader.service';
import { SKIP_GLOBAL_LOADER } from './loader.context';

/**
 * Wraps each HTTP request in global loader start/stop unless explicitly skipped.
 */
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private readonly httpLoaderService: HttpLoaderService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldSkipLoader = request.context.get(SKIP_GLOBAL_LOADER);

    if (!shouldSkipLoader) {
      this.httpLoaderService.start();
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!shouldSkipLoader) {
          this.httpLoaderService.stop();
        }
      })
    );
  }
}
